export default "__VITE_ASSET__DW5fq43x__"